export const getMaskedCreditCard = (
  text: string,
  noMaskLength: number = 4
): string | null => {
  const cleanText = text.replace(/ +/g, '');
  const cleanTextLength = cleanText.length;
  const CARD_NUMBER_LENGTH = 16;

  if (cleanTextLength !== CARD_NUMBER_LENGTH) {
    return null;
  }

  const noMaskText = cleanText.substr(-noMaskLength);
  const segments =
    noMaskText.padStart(cleanTextLength, '*').match(/.{4}/g) || [];
  const result = segments.join(' ');

  return result;
};
